/**
 * Runs a full storage recount from the R2 bucket (`adminRecalculateStorage`)
 * and reports the result. The same recount runs every night at 03:00 IST.
 */
import { Button, Tooltip } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconDatabase } from '@tabler/icons-react';
import { useState } from 'react';

import { callAdmin } from '@/lib/firebase';
import { fmtBytes } from '@/lib/format';

export function RecalculateStorageButton({ onDone }: { onDone?: () => void }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data: r } = await callAdmin.recalculateStorage({});
      notifications.show({
        title: 'Storage recalculated',
        message:
          `${r.objects.toLocaleString('en-IN')} files · ${fmtBytes(r.chargedBytes)} across ${r.studiosWithFiles} studios`
          + (r.orphanFiles ? ` · ${r.orphanFiles} orphaned file(s) (${fmtBytes(r.orphanBytes)}) not charged` : '')
          + ` · ${r.orgsUpdated} studio total(s) corrected.`,
        color: 'green',
        autoClose: 10000,
      });
      onDone?.();
    } catch (err) {
      notifications.show({ title: 'Recalculation failed', message: (err as Error).message, color: 'red' });
    } finally {
      setBusy(false);
    }
  };
  return (
    <Tooltip label="Recount every studio's files from storage (also runs nightly)" withArrow>
      <Button variant="default" size="xs" leftSection={<IconDatabase size={14} />} loading={busy} onClick={run}>
        Recalculate storage
      </Button>
    </Tooltip>
  );
}
